import { h } from 'preact';
import * as BaseComp from 'components/shared/background/background.js';
// import s from 'components/shared/background/background.sss';

export default class Background extends BaseComp.default {
	render() { return };
}
